import { gql } from "apollo-boost";

export const sessaoOneQuery = gql`
  query sessaoOneQuery($id: Int!) {
    sessaoOne(id: $id) {
      id
      nome
      inicio
      fim
      maximo_participantes
      convidados{
        id
        usuario {
          id
          nome
        }
        grupo{
          id
          nome
        }
        papel {
          id
          nome
        }
      }
      gravar
      permite_acesso_via_link
      acesso_via_link_requer_email
      acesso_via_link_requer_instituicao
      acesso_via_link_requer_cargo
      acesso_via_link_maximo_visitantes
      texto_convite
      layout_participante {
        id
        id_descritivo
        nome
      }
      participante_pode_enviar_chat
    }
  }
`;

export const organizadorSessoesAgendadasListQuery = gql`
query organizadorSessoesAgendadasListQuery ( $arquivado: Boolean ) {
  organizadorSessoesAgendadasList ( archived: $arquivado ) {
    id
    nome
    inicio
    fim
  }
}
`;

export const organizadorSessoesAndamentoListQuery = gql`
query organizadorSessoesAndamentoListQuery {
  organizadorSessoesAndamentoList {
    id
    nome
    inicio
    fim
    permite_acesso_via_link
    layout_participante {
        id_descritivo
    }
    transmitindo
    stream_url
    stream_key
  }
}
`;


export const gerenciarSessoesListForEnumQuery = gql`
query gerenciarSessoesListQuery ( $arquivado: Boolean ) {
  gerenciarSessoesList ( archived: $arquivado ) {
    id
    maximo_participantes
    nome
  }
}
`;

export const gerenciarSessoesArquivarMutation = gql`
  mutation gerenciarSessoesArquivar($id: Int) {
    sessaoArchive(id: $id) {
      id
    }
  }
`;

export const gerenciarSessoesRestaurarMutation = gql`
  mutation gerenciarSessoesRestaurar($id: Int!) {
    sessaoRestore(id: $id) {
      id
    }
  }
`;

export const gerenciarSessoesOne = gql`
  query gerenciarSessoesOne($id: Int) {
    sessaoOne(id: $id) {
      id
      nome
      maximo_participantes
    }
  }
`;

export const gerenciarSessoesSave = gql`
  mutation gerenciarSessoesSave($input: SessaoInput!) {
    sessoesave(input: $input) {
      id
    }
  }
`;

export const participanteSessoesAndamentoListQuery = gql`
  query participanteSessoesAndamentoListQuery {
    participanteSessoesAndamentoList {
      id
      nome
      maximo_participantes
      inicio
      fim
      slug
    }
  }
`;

export const participanteSessoesAgendadasListQuery = gql`
  query participanteSessoesAgendadasListQuery {
    participanteSessoesAgendadasList {
      id
      nome
      maximo_participantes
      inicio
      fim
      slug
    }
  }
`;

export const participanteSessoesEncerradasListQuery = gql`
  query participanteSessoesEncerradasListQuery {
    participanteSessoesEncerradasList {
      id
      tempo_conectado
      sessao {
        id
        nome
        maximo_participantes
        inicio
        fim
      }
      gravacoes {
        id
        inicio
        fim
        publicada
        url_ver
        url_baixar_video
      }
      videos {
        id
        gravacao_bbb_id
        sessao_id
        nome
        inicio
        layout_video {
          id
          id_descritivo
          nome
        }
        fl_partes
        json_partes
        url_video
        publicado
      }
    }
  }
`;

export const prolongaSessaoPorId = gql`
  mutation ($id: Int!, $novaDataFim: String) {
    prolongaSessaoPorId(id: $id, novaDataFim: $novaDataFim)
  }
`;

export const removeSessaoPorId = gql`
  mutation ($id: Int!) {
    removeSessaoPorId(id: $id)
  }
`;

export const clonaSessaoPorId = gql`
  mutation ($id: Int!) {
    clonaSessaoPorId(id: $id)
  }
`;

export const encerraSessaoPorId = gql`
  mutation ($id: Int!) {
    encerraSessaoPorId(id: $id)
  }
`;

export const encerraTransmissaoPorId = gql`
  mutation ($id: Int!) {
    encerraTransmissaoPorId(id: $id)
  }
`;

export const iniciaTransmissao = gql`
  mutation ($id: Int!, $stream_url: String!, $stream_key: String!, $skip_start: Boolean!) {
    iniciaTransmissao(id: $id, stream_url: $stream_url, stream_key: $stream_key, skip_start: $skip_start)
  }
`;

export const alteraPublicacaoSessao = gql`
  mutation ($id: Int!, $publicada: Int!) {
    alteraPublicacaoSessao(id: $id, publicada: $publicada)
  }
`;

export const adicionaParticipanteSessao = gql`
    mutation ($sessaoId: Int!, $participanteId: Int!, $papelId: Int!) {
      adicionaParticipante(sessaoId: $sessaoId, participanteId: $participanteId, papelId: $papelId)
    }
`;

export const organizadorSessoesEncerradasQuery = gql`
  query organizadorSessoesEncerradasQuery {
    organizadorSessoesEncerradasList {
      id
      nome
      maximo_participantes
      inicio
      fim
    }
  }
`;
export const organizadorRelatorioParticipacaoQuery = gql`
  query organizadorRelatorioParticipacaoQuery ($sessao: Int!, $jsonParamsRelatorio: String!) {
    organizadorRelatorioParticipacao(sessao: $sessao, jsonParamsRelatorio: $jsonParamsRelatorio) {
        value
    }
  }
`;

export const organizadorSessoesEncerradasPopupInfoQuery = gql`
  query organizadorSessoesEncerradasPopupQuery($id: Int!) {
    sessaoOne(id: $id) {
      id
      nome
      inicio
      fim
      maximo_participantes
      convidados{
        id
        usuario {
          id
          nome
        }
        grupo{
          id
          nome
        }
        papel {
          id
          nome
        }
      }
      gravar
      texto_convite
      participacoes{
        id
        usuario{
          id
          identificador
          nome
          email
        }
        visitante{
          id
          nome
          email
        }
        tempo_total_segundos
        entrada
        saida
        possui_evento_iniciar_gravacao
      }
      gravacoes{
        id
        inicio
        fim
        created_at
        publicada
        url_ver
        url_baixar_video
      }
    }
  }
`;

export const ModalExibirConvidadosSessaoQuery = gql`
  query ModalExibirConvidadosSessao($sessionId: Int!) {
    sessaoOne(id: $sessionId) {
      id
      nome
      maximo_participantes
      convidados{
        id
        usuario {
          id
          nome
        }
        grupo{
          id
          nome
        }
        papel {
          id
          nome
        }
      }
    }
  }
`

export const ModalExibirLinkAcessoQuery = gql`
  query ModalExibirLinkAcesso($sessionId: Int!) {
    sessaoOne(id: $sessionId) {
      id
      nome
      slug
      texto_convite
    }
  }
`

/* Querys usadas para o acesso à sessão*/
export const sessionBySlugAndParticipantQuery = gql`
  query sessionBySlugAndParticipantQuery ($slug: String!) {
    sessionBySlugAndParticipant (slug: $slug) {
      id
      is_archive
      nome
      maximo_participantes
      inicio
      fim
      acesso_via_link_requer_email
      acesso_via_link_requer_instituicao
      acesso_via_link_requer_cargo
    }
    horaAtualQuery {
      value
    }
  }
`;

export const participanteEntrarSessao = gql`
  mutation ($slug: String!) {
      participanteEntrarSessao(slug: $slug)
  }
`;

export const desconhecidoEntrarSessao = gql`
  mutation ($slug: String!, $desconhecidoSessionId: String!) {
      desconhecidoEntrarSessao(slug: $slug, desconhecidoSessionId: $desconhecidoSessionId)
  }
`;